import React from 'react';
import { motion } from 'framer-motion';
const items = [{
  title: 'Weekend sacrificati',
  desc: 'Sei stanco di rinunciare al sabato e alla domenica per costruire verifiche di contabilità e correggere bilanci da zero.'
}, {
  title: 'Serate senza fine',
  desc: 'Arrivi a casa esausto e devi ancora preparare gli esercizi sulla Partita Doppia per la lezione del giorno dopo.'
}, {
  title: 'Studenti che non capiscono',
  desc: 'Senti che i tuoi studenti sono bloccati dal Bilancio d\'Esercizio "vecchio stile" e perdono motivazione durante le lezioni.'
}, {
  title: 'Programmazione di livello',
  desc: 'Vuoi consegnare al Dirigente una programmazione moderna, documentata e perfettamente allineata alle linee guida MIM 2025/2026.'
}, {
  title: 'Seconda Prova con ansia',
  desc: 'Non hai simulazioni pronte per preparare i tuoi studenti alla Maturità e la Seconda Prova ti crea stress ogni anno.'
}, {
  title: 'Tempo per la didattica',
  desc: 'Vuoi smettere di fare il "cercatore di esercizi su Google" e tornare a concentrarti sull\'insegnare davvero.'
}];
export function ForYouChecklist() {
  return <section className="py-10 sm:py-12 px-4 bg-brand-card/50 border-y border-brand-orange/10 relative" data-id="element-133">
      <div className="max-w-4xl mx-auto" data-id="element-134">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-135">
          <p className="text-xs font-black uppercase tracking-widest text-brand-orange mb-3" data-id="element-136">
            Fatti riconoscere
          </p>
          <h2 className="text-3xl sm:text-4xl font-black text-brand-cream mb-3 leading-tight" data-id="element-137">
            Questo Metodo è{' '}
            <span className="bg-gradient-to-r from-brand-orange via-brand-amber to-brand-gold bg-clip-text text-transparent" data-id="element-138">
              per te
            </span>{' '}
            se ti riconosci qui sotto.
          </h2>
          <p className="text-base sm:text-lg text-gray-400" data-id="element-139">
            Basta che uno solo di questi punti ti rappresenti.
          </p>
        </motion.div>

        <div className="space-y-4" data-id="element-140">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="flex gap-4 items-start bg-brand-dark p-5 rounded-xl border border-white/5 hover:border-brand-orange/30 transition-colors" data-id="element-141">
              <span className="text-2xl shrink-0 mt-0.5" data-id="element-142">🔴</span>
              <div data-id="element-143">
                <h3 className="text-base sm:text-lg font-black text-brand-cream uppercase mb-1" data-id="element-144">
                  {item.title}
                </h3>
                <p className="text-sm sm:text-base text-gray-300 font-medium leading-relaxed" data-id="element-145">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-8 text-center bg-gradient-to-r from-brand-orange/15 via-brand-amber/10 to-brand-gold/15 border border-brand-orange/40 rounded-2xl py-4 px-5" data-id="element-146">
          <p className="text-brand-cream font-bold text-base sm:text-lg leading-snug" data-id="element-147">
            ✓ Allora il{' '}
            <span className="bg-gradient-to-r from-brand-orange via-brand-amber to-brand-gold bg-clip-text text-transparent font-black" data-id="element-148">
              Metodo Economia Aziendale Pro™
            </span>{' '}
            è stato pensato esattamente per te.
          </p>
        </motion.div>
      </div>
    </section>;
}